import type { ColumnDef } from "@tanstack/react-table"

import TextLink from "@/components/text-link"
import { Badge } from "@/components/ui/badge"
import { adminAccountPath, adminUserPath } from "@/routes"
import type { User } from "@/types"

export const columns: ColumnDef<User>[] = [
  {
    accessorKey: "name",
    enableSorting: true,
    header: "Name/Email",
    cell: ({ row }) => {
      return (
        <TextLink href={adminUserPath(row.original.uid)} as="div" prefetch>
          <div className="font-medium">{row.original.name}</div>
          <div className="text-muted-foreground text-sm">
            {row.original.email}
          </div>
        </TextLink>
      )
    },
  },
  {
    accessorKey: "account.uid",
    header: "Account",
    cell: ({ row }) =>
      row.original.account?.uid ? (
        <TextLink
          href={adminAccountPath(row.original.account?.uid)}
          as="div"
          prefetch
        >
          {row.original.account?.name}
        </TextLink>
      ) : null,
  },
  {
    accessorKey: "current_sign_in_at",
    enableSorting: true,
    header: "Last Login",
    cell: ({ row }) =>
      row.original.current_sign_in_at
        ? new Date(row.original.current_sign_in_at).toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "short",
              day: "numeric",
            },
          )
        : "-",
  },
  {
    accessorKey: "created_at",
    enableSorting: true,
    header: "Created",
    cell: ({ row }) =>
      new Date(row.original.created_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
  },
  {
    accessorKey: "state",
    enableSorting: true,
    header: "Status",
    cell: ({ row }) => (
      <Badge
        variant={row.original.state === "active" ? "operational" : "draft"}
        className="capitalize"
      >
        {row.original.state}
      </Badge>
    ),
  },
]
